import intl from 'react-intl-universal';
import exportIcon from '../../../../assets/icons/export.svg';
import { DASHBOARD_DETAIL_ACTIONS } from '../../../../utils/constants/dashboard';
import { useDownloadPDF } from '../hooks/useDownloadPDF';
import { useContext } from 'react';
import { DashboardContext } from '../../DashboardContext';
import {
  Icon,
  OverflowMenuItem,
  tailwindOverride,
  Typography,
} from '@getsynapse/design-system';

export const ExportPdfOverflowMenuItem = (props: { gridRef: any }) => {
  const { gridRef } = props;

  const { dashboardId } = useContext(DashboardContext);

  const { downloadPDF } = useDownloadPDF({
    ref: gridRef,
    name: `dashboards_export_${dashboardId}`,
  });

  const item = {
    label: intl.get('DASHBOARD_DETAIL.ACTION.EXPORT_PDF'),
    iconSrc: exportIcon,
    onSelect: async () => {
      await downloadPDF();
    },
    action: DASHBOARD_DETAIL_ACTIONS.EXPORT_PDF,
  };

  return (
    <OverflowMenuItem
      key={item.label}
      className='flex items-center space-x-2'
      onSelect={item.onSelect}
      data-cy={`dashboard-${dashboardId}__actions-popover__${item.action}`}
    >
      <Icon
        src={item.iconSrc || ''}
        className={tailwindOverride(
          'fill-current text-primary group-hover:fill-current group-hover:text-secondary-darker text-lg',
          {
            'text-xl': item.iconSrc,
          }
        )}
      />
      <Typography
        variant='label'
        className='group-hover:text-secondary-darker cursor-pointer'
      >
        {item.label}
      </Typography>
    </OverflowMenuItem>
  );
};
